import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Builder4ra56zvvku0a as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance14tgug8r8maei as Companion_getInstance } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { withContext3b6r4oljqqy1b as withContext } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Builder3d75eph7uovs3 as Builder_0 } from './network/http/HttpNetworkTransport.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Builder1suvx83rlbrz1 as Builder_1 } from './network/websocket/WebSocketNetworkTransport.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDurationba1nlt78o6vu as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Builder3moivcm5iuump as Builder_2 } from './network/ws/WebSocketNetworkTransport.mjs';
import { get_defaultDispatcher3rblue9uzsji2 as get_defaultDispatcher } from './internal/dispatchers.js.mjs';
import {
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  cancel36mj9lv3a0whl as cancel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { ConcurrencyInfo3mmnli95yq2g0 as ConcurrencyInfo } from './ConcurrencyInfo.mjs';
import { NetworkInterceptor22fszyorwx7pt as NetworkInterceptor } from './interceptor/NetworkInterceptor.mjs';
import { RetryOnErrorInterceptor2wqvvqzzzk2ot as RetryOnErrorInterceptor } from './interceptor/RetryOnErrorInterceptor.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { ApolloCallpwdxdy18rzuy as ApolloCall } from './ApolloCall.mjs';
import { channelFlow1or0c85tk04v1 as channelFlow } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { buffer2o7vhreze5nfc as buffer } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { DefaultInterceptorChain10weji0clzo5q as DefaultInterceptorChain } from './interceptor/ApolloInterceptor.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_allInterceptors__eyuk02($this) {
  var tmp0 = $this.allInterceptors$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('allInterceptors', 1, tmp, ApolloClient$_get_allInterceptors_$ref_sf7sgp(), null);
  return tmp0.get_value_j01efc_k$();
}
var BuilderClass;
function Builder_3() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this._customScalarAdaptersBuilder_1 = new (Builder())();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp._beforeCacheInterceptors_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0._beforeAutoPersistedQueriesInterceptors_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1._beforeRetryOnErrorInterceptors_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var tmp_2 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_2._beforeNetworkInterceptors_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var tmp_3 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_3._httpInterceptors_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.httpInterceptors_1 = this._httpInterceptors_1;
        this.executionContext_1 = Companion_getInstance().Empty_1;
        this.url_1 = null;
        this.httpMethod_1 = null;
        this.httpHeaders_1 = null;
        this.sendApqExtensions_1 = null;
        this.sendDocument_1 = null;
        this.enableAutoPersistedQueries_1 = null;
        this.canBeBatched_1 = null;
        this.ignoreUnknownKeys_1 = null;
        this.networkTransport_1 = null;
        this.subscriptionNetworkTransport_1 = null;
        this.dispatcher_1 = null;
        this.httpServerUrl_1 = null;
        this.httpEngine_1 = null;
        this.webSocketServerUrl_1 = null;
        this.webSocketIdleTimeoutMillis_1 = null;
        this.wsProtocolFactory_1 = null;
        this.httpExposeErrorBody_1 = null;
        this.webSocketEngine_1 = null;
        this.webSocketReopenWhen_1 = null;
        this.webSocketReopenServerUrl_1 = null;
        this.retryOnError_1 = null;
        this.retryOnErrorInterceptor_1 = null;
        this.failFastIfOffline_1 = null;
        this.cacheInterceptor_1 = null;
        this.autoPersistedQueryInterceptor_1 = null;
        this.sendEnhancedClientAwareness_1 = true;
      }
      get_customScalarAdapters_jxtx62_k$() {
        return this._customScalarAdaptersBuilder_1.build_1k0s4u_k$();
      }
      get_interceptors_e78bex_k$() {
        return plus(plus(plus(this._beforeCacheInterceptors_1, this._beforeAutoPersistedQueriesInterceptors_1), this._beforeRetryOnErrorInterceptors_1), this._beforeNetworkInterceptors_1);
      }
      sendEnhancedClientAwareness_gxmi9z_k$(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.sendEnhancedClientAwareness_1 = sendEnhancedClientAwareness;
        return this;
      }
      failFastIfOffline_9dg0ak_k$(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.failFastIfOffline_1 = failFastIfOffline;
        return this;
      }
      retryOnError_an1r9o_k$(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.retryOnError_1 = retryOnError;
        return this;
      }
      retryOnErrorInterceptor_dwmw4y_k$(retryOnErrorInterceptor) {
        // Inline function 'kotlin.apply' call
        this.retryOnErrorInterceptor_1 = retryOnErrorInterceptor;
        return this;
      }
      cacheInterceptor_z7dz4h_k$(cacheInterceptor) {
        // Inline function 'kotlin.apply' call
        this.cacheInterceptor_1 = cacheInterceptor;
        return this;
      }
      autoPersistedQueriesInterceptor_kg0xu9_k$(autoPersistedQueryInterceptor) {
        // Inline function 'kotlin.apply' call
        this.autoPersistedQueryInterceptor_1 = autoPersistedQueryInterceptor;
        return this;
      }
      url_z52zc8_k$(url) {
        // Inline function 'kotlin.apply' call
        this.url_1 = url;
        return this;
      }
      httpMethod_x6p6an_k$(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.httpMethod_1 = httpMethod;
        return this;
      }
      httpHeaders_51sthb_k$(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.httpHeaders_1 = httpHeaders;
        return this;
      }
      sendApqExtensions_jf5wma_k$(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.sendApqExtensions_1 = sendApqExtensions;
        return this;
      }
      sendDocument_qq2yvh_k$(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.sendDocument_1 = sendDocument;
        return this;
      }
      enableAutoPersistedQueries_n8ln2t_k$(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.enableAutoPersistedQueries_1 = enableAutoPersistedQueries;
        return this;
      }
      canBeBatched_tnoh06_k$(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.canBeBatched_1 = canBeBatched;
        return this;
      }
      ignoreUnknownKeys_bt649o_k$(ignoreUnknownKeys) {
        // Inline function 'kotlin.apply' call
        this.ignoreUnknownKeys_1 = ignoreUnknownKeys;
        return this;
      }
      serverUrl_qr5kj6_k$(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.httpServerUrl_1 = serverUrl;
        return this;
      }
      httpServerUrl_9l8kql_k$(httpServerUrl) {
        // Inline function 'kotlin.apply' call
        this.httpServerUrl_1 = httpServerUrl;
        return this;
      }
      httpEngine_my70qx_k$(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.httpEngine_1 = httpEngine;
        return this;
      }
      httpExposeErrorBody_26mwuq_k$(httpExposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.httpExposeErrorBody_1 = httpExposeErrorBody;
        return this;
      }
      httpInterceptors_pzn1ai_k$(httpInterceptors) {
        // Inline function 'kotlin.apply' call
        this._httpInterceptors_1.clear_j9egeb_k$();
        this._httpInterceptors_1.addAll_h3ej1q_k$(httpInterceptors);
        return this;
      }
      webSocketServerUrl_2yhon6_k$(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.webSocketServerUrl_1 = webSocketServerUrl;
        return this;
      }
      webSocketServerUrl_gnz1si_k$(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.webSocketReopenServerUrl_1 = webSocketServerUrl;
        return this;
      }
      webSocketIdleTimeoutMillis_on3p6h_k$(webSocketIdleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.webSocketIdleTimeoutMillis_1 = webSocketIdleTimeoutMillis;
        return this;
      }
      wsProtocol_qffn3g_k$(wsProtocolFactory) {
        // Inline function 'kotlin.apply' call
        this.wsProtocolFactory_1 = wsProtocolFactory;
        return this;
      }
      webSocketEngine_xmvjlq_k$(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.webSocketEngine_1 = webSocketEngine;
        return this;
      }
      webSocketReopenWhen_vy9af7_k$(webSocketReopenWhen) {
        // Inline function 'kotlin.apply' call
        this.webSocketReopenWhen_1 = webSocketReopenWhen;
        return this;
      }
      networkTransport_gca8vb_k$(networkTransport) {
        // Inline function 'kotlin.apply' call
        this.networkTransport_1 = networkTransport;
        return this;
      }
      subscriptionNetworkTransport_hgmmsq_k$(subscriptionNetworkTransport) {
        // Inline function 'kotlin.apply' call
        this.subscriptionNetworkTransport_1 = subscriptionNetworkTransport;
        return this;
      }
      customScalarAdapters_tt0vjc_k$(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this._customScalarAdaptersBuilder_1.clear_j9egeb_k$();
        this._customScalarAdaptersBuilder_1.addAll_ls9ou1_k$(customScalarAdapters);
        return this;
      }
      dispatcher_ziafrz_k$(dispatcher) {
        // Inline function 'kotlin.apply' call
        this.dispatcher_1 = dispatcher;
        return this;
      }
      executionContext_as7v8i_k$(executionContext) {
        // Inline function 'kotlin.apply' call
        this.executionContext_1 = executionContext;
        return this;
      }
      build_1k0s4u_k$() {
        return new (ApolloClient())(this.copy_1tks5_k$());
      }
      copy_1tks5_k$() {
        // Inline function 'kotlin.also' call
        var this_0 = (new (Builder_3())()).customScalarAdapters_tt0vjc_k$(this._customScalarAdaptersBuilder_1.build_1k0s4u_k$());
        this_0._beforeCacheInterceptors_1.addAll_h3ej1q_k$(this._beforeCacheInterceptors_1);
        this_0._beforeAutoPersistedQueriesInterceptors_1.addAll_h3ej1q_k$(this._beforeAutoPersistedQueriesInterceptors_1);
        this_0._beforeRetryOnErrorInterceptors_1.addAll_h3ej1q_k$(this._beforeRetryOnErrorInterceptors_1);
        this_0._beforeNetworkInterceptors_1.addAll_h3ej1q_k$(this._beforeNetworkInterceptors_1);
        return this_0.dispatcher_ziafrz_k$(this.dispatcher_1).executionContext_as7v8i_k$(this.executionContext_1).url_z52zc8_k$(this.url_1).httpMethod_x6p6an_k$(this.httpMethod_1).httpHeaders_51sthb_k$(this.httpHeaders_1).httpServerUrl_9l8kql_k$(this.httpServerUrl_1).httpEngine_my70qx_k$(this.httpEngine_1).httpExposeErrorBody_26mwuq_k$(this.httpExposeErrorBody_1).httpInterceptors_pzn1ai_k$(this.httpInterceptors_1).sendApqExtensions_jf5wma_k$(this.sendApqExtensions_1).sendDocument_qq2yvh_k$(this.sendDocument_1).enableAutoPersistedQueries_n8ln2t_k$(this.enableAutoPersistedQueries_1).canBeBatched_tnoh06_k$(this.canBeBatched_1).ignoreUnknownKeys_bt649o_k$(this.ignoreUnknownKeys_1).networkTransport_gca8vb_k$(this.networkTransport_1).subscriptionNetworkTransport_hgmmsq_k$(this.subscriptionNetworkTransport_1).webSocketServerUrl_2yhon6_k$(this.webSocketServerUrl_1).webSocketServerUrl_gnz1si_k$(this.webSocketReopenServerUrl_1).webSocketEngine_xmvjlq_k$(this.webSocketEngine_1).webSocketReopenWhen_vy9af7_k$(this.webSocketReopenWhen_1).webSocketIdleTimeoutMillis_on3p6h_k$(this.webSocketIdleTimeoutMillis_1).wsProtocol_qffn3g_k$(this.wsProtocolFactory_1).retryOnError_an1r9o_k$(this.retryOnError_1).retryOnErrorInterceptor_dwmw4y_k$(this.retryOnErrorInterceptor_1).cacheInterceptor_z7dz4h_k$(this.cacheInterceptor_1).autoPersistedQueriesInterceptor_kg0xu9_k$(this.autoPersistedQueryInterceptor_1).failFastIfOffline_9dg0ak_k$(this.failFastIfOffline_1).sendEnhancedClientAwareness_gxmi9z_k$(this.sendEnhancedClientAwareness_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_3);
    BuilderClass = $;
  }
  return BuilderClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $_0 {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      *emit_t92u1f_k$(value, $completion) {
        return yield* $(this.function_1(value, $completion), $completion);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
function ApolloClient$_get_allInterceptors_$ref_sf7sgp() {
  return constructCallableReference((p0) => _get_allInterceptors__eyuk02(p0), 1, 0, 224);
}
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda($this_channelFlow) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* $this_channelFlow.send_44jogj_k$(it, $completion);
    return Unit_instance;
  }), 1);
}
function ApolloClient$executeAsFlowInternal$slambda$slambda(this$0, $apolloRequest, $throwing, $this_channelFlow) {
  return constructCallableReference(($this$withContext, $completion) => orPromise($completion, function *($completion) {
    var tmp = this$0.apolloResponses_fnbq63_k$($apolloRequest, $throwing);
    var tmp_0 = ApolloClient$executeAsFlowInternal$slambda$slambda$slambda($this_channelFlow);
    yield* tmp.collect_aksokr_k$(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp_0), $completion);
    return Unit_instance;
  }), 1);
}
function ApolloClient$executeAsFlowInternal$slambda(this$0, $apolloRequest, $throwing) {
  return constructCallableReference(($this$channelFlow, $completion) => orPromise($completion, function *($completion) {
    yield* withContext(this$0.concurrencyInfo_1.dispatcher_1, ApolloClient$executeAsFlowInternal$slambda$slambda(this$0, $apolloRequest, $throwing, $this$channelFlow), $completion);
    return Unit_instance;
  }), 1);
}
function ApolloClient$apolloResponses$slambda() {
  return constructCallableReference((response, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if (!(response.exception_1 == null)) {
      throw ensureNotNull(response.exception_1);
    }
    return Unit_instance;
  }), 1);
}
var ApolloClientClass;
function ApolloClient() {
  if (ApolloClientClass === VOID) {
    class $ {
      constructor(builder) {
        this.builder_1 = builder;
        this.interceptors_1 = this.builder_1.get_interceptors_e78bex_k$();
        this.customScalarAdapters_1 = this.builder_1.get_customScalarAdapters_jxtx62_k$();
        this.cacheInterceptor_1 = this.builder_1.cacheInterceptor_1;
        this.autoPersistedQueryInterceptor_1 = this.builder_1.autoPersistedQueryInterceptor_1;
        this.retryOnError_1 = this.builder_1.retryOnError_1;
        this.retryOnErrorInterceptor_1 = this.builder_1.retryOnErrorInterceptor_1;
        this.failFastIfOffline_1 = this.builder_1.failFastIfOffline_1;
        this.sendEnhancedClientAwareness_1 = this.builder_1.sendEnhancedClientAwareness_1;
        this.executionContext_1 = this.builder_1.executionContext_1;
        this.url_1 = this.builder_1.url_1;
        this.httpMethod_1 = this.builder_1.httpMethod_1;
        this.httpHeaders_1 = this.builder_1.httpHeaders_1;
        this.sendApqExtensions_1 = this.builder_1.sendApqExtensions_1;
        this.sendDocument_1 = this.builder_1.sendDocument_1;
        this.enableAutoPersistedQueries_1 = this.builder_1.enableAutoPersistedQueries_1;
        this.canBeBatched_1 = this.builder_1.canBeBatched_1;
        this.ignoreUnknownKeys_1 = this.builder_1.ignoreUnknownKeys_1;
        var tmp = this;
        var tmp_0;
        if (!(this.builder_1.networkTransport_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.builder_1.httpServerUrl_1 == null)) {
            var message = "Apollo: 'httpServerUrl' has no effect if 'networkTransport' is set. Configure httpServerUrl on the networkTransport directly.";
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!(this.builder_1.httpEngine_1 == null)) {
            var message_0 = "Apollo: 'httpEngine' or 'okHttpClient' has no effect if 'networkTransport' is set. Configure httpEngine on the networkTransport directly.";
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_0));
          }
          // Inline function 'kotlin.check' call
          if (!this.builder_1.httpInterceptors_1.isEmpty_y1axqb_k$()) {
            var message_1 = "Apollo: 'addHttpInterceptor' has no effect if 'networkTransport' is set. Configure the interceptors on the networkTransport directly.";
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_1));
          }
          // Inline function 'kotlin.check' call
          if (!(this.builder_1.httpExposeErrorBody_1 == null)) {
            var message_2 = "Apollo: 'httpExposeErrorBody' has no effect if 'networkTransport' is set. Configure httpExposeErrorBody on the networkTransport directly.";
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_2));
          }
          tmp_0 = ensureNotNull(this.builder_1.networkTransport_1);
        } else {
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder_0())()).serverUrl_kg2d9h_k$(this.builder_1.httpServerUrl_1);
          if (!(this.builder_1.httpEngine_1 == null)) {
            this_0.httpEngine_5bmjw8_k$(ensureNotNull(this.builder_1.httpEngine_1));
          }
          if (!(this.builder_1.httpExposeErrorBody_1 == null)) {
            this_0.exposeErrorBody_8ps9a7_k$(ensureNotNull(this.builder_1.httpExposeErrorBody_1));
          }
          tmp_0 = this_0.interceptors_a6mi5a_k$(this.builder_1.httpInterceptors_1).build_1k0s4u_k$();
        }
        tmp.networkTransport_1 = tmp_0;
        var tmp_1 = this;
        var tmp_2;
        if (!(this.builder_1.subscriptionNetworkTransport_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.builder_1.webSocketServerUrl_1 == null)) {
            var message_3 = "Apollo: 'webSocketServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_3));
          }
          // Inline function 'kotlin.check' call
          if (!(this.builder_1.webSocketEngine_1 == null)) {
            var message_4 = "Apollo: 'webSocketEngine' or 'okHttpClient' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketEngine on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_4));
          }
          // Inline function 'kotlin.check' call
          if (!(this.builder_1.webSocketIdleTimeoutMillis_1 == null)) {
            var message_5 = "Apollo: 'webSocketIdleTimeoutMillis' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketIdleTimeoutMillis on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_5));
          }
          // Inline function 'kotlin.check' call
          if (!(this.builder_1.wsProtocolFactory_1 == null)) {
            var message_6 = "Apollo: 'wsProtocolFactory' has no effect if 'subscriptionNetworkTransport' is set. Configure wsProtocolFactory on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_6));
          }
          // Inline function 'kotlin.check' call
          if (!(this.builder_1.webSocketReopenWhen_1 == null)) {
            var message_7 = "Apollo: 'webSocketReopenWhen' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenWhen on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_7));
          }
          // Inline function 'kotlin.check' call
          if (!(this.builder_1.webSocketReopenServerUrl_1 == null)) {
            var message_8 = "Apollo: 'webSocketReopenServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_8));
          }
          tmp_2 = ensureNotNull(this.builder_1.subscriptionNetworkTransport_1);
        } else {
          var tmp0_elvis_lhs = this.builder_1.webSocketServerUrl_1;
          var url = tmp0_elvis_lhs == null ? this.builder_1.httpServerUrl_1 : tmp0_elvis_lhs;
          var tmp_3;
          if (url == null) {
            tmp_3 = this.networkTransport_1;
          } else if (!(this.builder_1.webSocketEngine_1 == null) || !(this.builder_1.wsProtocolFactory_1 == null) || !(this.builder_1.webSocketReopenWhen_1 == null) || !(this.builder_1.webSocketReopenServerUrl_1 == null)) {
            // Inline function 'kotlin.apply' call
            var this_1 = (new (Builder_2())()).serverUrl_qr5kj6_k$(url);
            if (!(this.builder_1.webSocketEngine_1 == null)) {
              this_1.webSocketEngine_rs2r17_k$(ensureNotNull(this.builder_1.webSocketEngine_1));
            }
            if (!(this.builder_1.webSocketIdleTimeoutMillis_1 == null)) {
              this_1.idleTimeoutMillis_wso2tt_k$(ensureNotNull(this.builder_1.webSocketIdleTimeoutMillis_1));
            }
            if (!(this.builder_1.wsProtocolFactory_1 == null)) {
              this_1.protocol_ock0rt_k$(ensureNotNull(this.builder_1.wsProtocolFactory_1));
            }
            if (!(this.builder_1.webSocketReopenWhen_1 == null)) {
              this_1.reopenWhen_t7vydm_k$(this.builder_1.webSocketReopenWhen_1);
            }
            if (!(this.builder_1.webSocketReopenServerUrl_1 == null)) {
              this_1.serverUrl_t5qiad_k$(this.builder_1.webSocketReopenServerUrl_1);
            }
            tmp_3 = this_1.build_1k0s4u_k$();
          } else {
            // Inline function 'kotlin.apply' call
            var this_2 = (new (Builder_1())()).serverUrl_kg2d9h_k$(url);
            if (!(this.builder_1.webSocketIdleTimeoutMillis_1 == null)) {
              Companion_getInstance_0();
              // Inline function 'kotlin.time.Companion.milliseconds' call
              var this_3 = ensureNotNull(this.builder_1.webSocketIdleTimeoutMillis_1);
              var tmp$ret$26 = toDuration(this_3, DurationUnit_MILLISECONDS_getInstance());
              this_2.idleTimeout_i6w53x_k$(tmp$ret$26);
            }
            tmp_3 = this_2.build_1k0s4u_k$();
          }
          tmp_2 = tmp_3;
        }
        tmp_1.subscriptionNetworkTransport_1 = tmp_2;
        var tmp1_elvis_lhs = this.builder_1.dispatcher_1;
        var dispatcher = tmp1_elvis_lhs == null ? get_defaultDispatcher() : tmp1_elvis_lhs;
        this.concurrencyInfo_1 = new (ConcurrencyInfo())(dispatcher, CoroutineScope(dispatcher));
        this.networkInterceptor_1 = new (NetworkInterceptor())(this.networkTransport_1, this.subscriptionNetworkTransport_1);
        var tmp_4 = this;
        tmp_4.allInterceptors$delegate_1 = lazy(() => {
          // Inline function 'kotlin.collections.buildList' call
          // Inline function 'kotlin.collections.buildListInternal' call
          // Inline function 'kotlin.apply' call
          var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          this_0.addAll_h3ej1q_k$(this.builder_1._beforeCacheInterceptors_1);
          if (!(this.cacheInterceptor_1 == null)) {
            this_0.add_utx5q5_k$(this.cacheInterceptor_1);
          }
          this_0.addAll_h3ej1q_k$(this.builder_1._beforeAutoPersistedQueriesInterceptors_1);
          if (!(this.autoPersistedQueryInterceptor_1 == null)) {
            this_0.add_utx5q5_k$(this.autoPersistedQueryInterceptor_1);
          }
          this_0.addAll_h3ej1q_k$(this.builder_1._beforeRetryOnErrorInterceptors_1);
          var tmp0_elvis_lhs = this.retryOnErrorInterceptor_1;
          this_0.add_utx5q5_k$(tmp0_elvis_lhs == null ? RetryOnErrorInterceptor() : tmp0_elvis_lhs);
          this_0.addAll_h3ej1q_k$(this.builder_1._beforeNetworkInterceptors_1);
          this_0.add_utx5q5_k$(this.networkInterceptor_1);
          return this_0.build_nmwvly_k$();
        });
      }
      query_jcptxn_k$(query) {
        return ApolloCall().new_com_apollographql_apollo_ApolloCall_d8sxd7_k$(this, query);
      }
      mutation_qix1z8_k$(mutation) {
        return ApolloCall().new_com_apollographql_apollo_ApolloCall_d8sxd7_k$(this, mutation);
      }
      close_yn9xrc_k$() {
        cancel(this.concurrencyInfo_1.coroutineScope_1);
        this.networkTransport_1.dispose_3nnxhr_k$();
        this.subscriptionNetworkTransport_1.dispose_3nnxhr_k$();
      }
      executeAsFlowInternal_ds6yfe_k$(apolloRequest, throwing) {
        var flow = channelFlow(ApolloClient$executeAsFlowInternal$slambda(this, apolloRequest, throwing));
        return buffer(flow, 2147483647);
      }
      apolloResponses_fnbq63_k$(apolloRequest, throwing) {
        var apolloClient = this;
        // Inline function 'kotlin.apply' call
        var this_0 = apolloRequest.newBuilder_dnl2aj_k$();
        this_0.executionContext_as7v8i_k$(this.concurrencyInfo_1.plus_kymzvj_k$(this.customScalarAdapters_1).plus_kymzvj_k$(apolloClient.executionContext_1).plus_kymzvj_k$(this_0.executionContext_1));
        var tmp0_elvis_lhs = this_0.httpMethod_1;
        this_0.httpMethod_x6p6an_k$(tmp0_elvis_lhs == null ? apolloClient.httpMethod_1 : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this_0.sendApqExtensions_1;
        this_0.sendApqExtensions_jf5wma_k$(tmp1_elvis_lhs == null ? apolloClient.sendApqExtensions_1 : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this_0.sendDocument_1;
        this_0.sendDocument_qq2yvh_k$(tmp2_elvis_lhs == null ? apolloClient.sendDocument_1 : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this_0.enableAutoPersistedQueries_1;
        this_0.enableAutoPersistedQueries_n8ln2t_k$(tmp3_elvis_lhs == null ? apolloClient.enableAutoPersistedQueries_1 : tmp3_elvis_lhs);
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        if (!(this_0.ignoreApolloClientHttpHeaders_1 === true)) {
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs_0 = apolloClient.httpHeaders_1;
          var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
          this_1.addAll_h3ej1q_k$(tmp$ret$6);
        }
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_1 = this_0.httpHeaders_1;
        var tmp$ret$7 = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
        this_1.addAll_h3ej1q_k$(tmp$ret$7);
        var headers = this_1.build_nmwvly_k$();
        this_0.httpHeaders_51sthb_k$(headers);
        var tmp4_elvis_lhs = this_0.canBeBatched_1;
        var canBeBatched = tmp4_elvis_lhs == null ? apolloClient.canBeBatched_1 : tmp4_elvis_lhs;
        if (!(canBeBatched == null)) {
          this_0.addHttpHeader_irkgza_k$('X-APOLLO-CAN-BE-BATCHED', canBeBatched.toString());
        }
        var tmp5_elvis_lhs = this_0.retryOnError_1;
        var tmp;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = apolloClient.retryOnError_1;
          tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver(apolloRequest);
        } else {
          tmp = tmp5_elvis_lhs;
        }
        this_0.retryOnError_f7vl8x_k$(tmp);
        var tmp7_elvis_lhs = this_0.failFastIfOffline_1;
        this_0.failFastIfOffline_9dg0ak_k$(tmp7_elvis_lhs == null ? apolloClient.failFastIfOffline_1 : tmp7_elvis_lhs);
        var tmp8_elvis_lhs = this_0.ignoreUnknownKeys_1;
        this_0.ignoreUnknownKeys_bt649o_k$(tmp8_elvis_lhs == null ? apolloClient.ignoreUnknownKeys_1 : tmp8_elvis_lhs);
        this_0.sendEnhancedClientAwareness_gxmi9z_k$(apolloClient.sendEnhancedClientAwareness_1);
        var tmp9_elvis_lhs = this_0.url_1;
        this_0.url_z52zc8_k$(tmp9_elvis_lhs == null ? apolloClient.url_1 : tmp9_elvis_lhs);
        var request = this_0.build_1k0s4u_k$();
        // Inline function 'kotlin.let' call
        var it = (new (DefaultInterceptorChain())(_get_allInterceptors__eyuk02(this), 0)).proceed_ju3yum_k$(request);
        var tmp_0;
        if (throwing) {
          tmp_0 = onEach(it, ApolloClient$apolloResponses$slambda());
        } else {
          tmp_0 = it;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'ApolloClient');
    ApolloClientClass = $;
  }
  return ApolloClientClass;
}
//region block: exports
export {
  Builder_3 as Builder3lcn00uc5gcy3,
};
//endregion

//# sourceMappingURL=ApolloClient.mjs.map
